import selectMarket from 'lib/selectMarket'

export default function useSelectMarket() {
  return selectMarket
}
